"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwappablePropertyLogoLink = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importDefault(require("react"));
const SwappablePropertyLogoLink = (_a) => {
    var _b;
    var { link, locale, children } = _a, props = __rest(_a, ["link", "locale", "children"]);
    const { LinkComponent } = (0, epic_games_nav_shared_1.useLinkComponents)();
    const { isEmbeddedHeaderFooter } = (0, epic_games_nav_shared_1.determineExternal)(link.hrefTemplate);
    return (react_1.default.createElement(LinkComponent, Object.assign({ path: (_b = link.href) !== null && _b !== void 0 ? _b : "", isEmbedded: isEmbeddedHeaderFooter, locale: locale }, props), children));
};
exports.SwappablePropertyLogoLink = SwappablePropertyLogoLink;
//# sourceMappingURL=SwappablePropertyLogoLink.js.map